"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Text = _interopRequireDefault(require("./Text"));
var _EmptyButton = _interopRequireDefault(require("./EmptyButton"));
var _Icon = _interopRequireDefault(require("./Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const StyledText = (0, _styledComponents.default)(_Text.default).withConfig({
  displayName: "TextReveal__StyledText",
  componentId: "sc-1ej7son-0"
})(["display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;overflow:hidden;"], props => props.lines);
const defaultRender = ({
  onClick,
  show
}) => /*#__PURE__*/_react.default.createElement(_EmptyButton.default, {
  onClick: onClick,
  display: "flex",
  alignItems: "center",
  marginTop: "10px"
}, "See\xA0", show ? 'Less' : 'More', /*#__PURE__*/_react.default.createElement(_Icon.default, {
  iconSize: "25px",
  marginBottom: "-7px",
  className: `ls-icon icon-generalcaret${show ? 'up' : 'down'}medium`
}));
const TextReveal = ({
  lines,
  renderShowMore,
  children,
  ...props
}) => {
  const [show, setShow] = (0, _react.useState)();
  const [elm, setElm] = (0, _react.useState)();
  const isTruncated = (0, _react.useMemo)(() => elm && elm.scrollHeight > elm.clientHeight, [elm]);
  const onClick = () => setShow(!show);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledText, _extends({
    ref: ref => setElm(ref),
    lines: show ? undefined : lines
  }, props), children), isTruncated && renderShowMore({
    onClick,
    show
  }));
};
__signature__(TextReveal, "useState{[show, setShow]}\nuseState{[elm, setElm]}\nuseMemo{isTruncated}");
TextReveal.propTypes = {
  lines: _propTypes.default.number,
  renderShowMore: _propTypes.default.func,
  children: _propTypes.default.node
};
TextReveal.defaultProps = {
  lines: 3,
  renderShowMore: defaultRender,
  children: null
};
const _default = TextReveal;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(StyledText, "StyledText", "/Users/jake.clayton/frontend/ls-common-client/src/components/TextReveal.js");
  reactHotLoader.register(defaultRender, "defaultRender", "/Users/jake.clayton/frontend/ls-common-client/src/components/TextReveal.js");
  reactHotLoader.register(TextReveal, "TextReveal", "/Users/jake.clayton/frontend/ls-common-client/src/components/TextReveal.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/TextReveal.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();